/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Constants } from 'app/shared/models/constants.model';
import { environment } from 'environments/environment';
import { ToastrTranslationsNotificationService } from 'app/shared/services/toastr-translations-notification.service';

@Injectable()
export class EventDetailsService {
  constructor(
    private httpClient: HttpClient,
    private toastrTranslationsNotificationService: ToastrTranslationsNotificationService
  ) {}

  getEventById(payload: any) {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/events/${payload.id}`));
  }

  getEventAthletes(payload: any) {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/players/event/${payload.id}`));
  }

  getEventClips(payload: any) {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/games/clipped/event/${payload.id}`));
  }

  getEventAthletesV2(payload: any) {
    return this.httpClient.get(`${environment.apiHostname}/v1/events/${payload.id}/athletes`).pipe(
      map((response: any) => {
        if (response.result.success) {
          const data: any[] = response.data;
          const uniqueAthletes: any[] = [];
          for (const athlete of data) {
            if (uniqueAthletes.filter((a) => a.id === athlete.id).length === 0) {
              athlete.type = Constants.USER_TYPE.ATHLETE;
              uniqueAthletes.push(athlete);
            }
          }
          return uniqueAthletes;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  getEventAthletesPublic(payload: any) {
    return this.httpClient.get(`${environment.apiHostname}/v1/events/guest/${payload.id}/athletes`).pipe(
      map((response: any) => {
        if (response.result.success) {
          const data: any[] = response.data;
          const uniqueAthletes: any[] = [];
          for (const athlete of data) {
            if (uniqueAthletes.filter((a) => a.id === athlete.id).length === 0) {
              athlete.type = Constants.USER_TYPE.ATHLETE;
              uniqueAthletes.push(athlete);
            }
          }
          return uniqueAthletes;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  getEventGames(payload: any) {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/games/event/${payload.id}`));
  }

  getEventGamesPublic(payload: any) {
    return this.handleResponse(this.httpClient.get(`${environment.apiHostname}/v1/games/guest/event/${payload.id}`));
  }

  getEventFeatured(payload: any) {
    return this.handleResponse(
      this.httpClient.get(`${environment.apiHostname}/v1/events/list/${payload.id}/featured-videos`)
    );
  }

  handleResponse(observable: Observable<any>) {
    return observable.pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }
}
